/* SMAEL — teste de capas: sincroniza links, sorteia a cor do visitante (modo A/B) e mede aparições/cliques.
   Medição: por produto + cor, conta quantas vezes o card apareceu (>=50% visível por ~0,8 s) e quantos cliques recebeu.
   Sem cookies e sem identificar pessoa: só contagens anônimas em lote para a planilha (Apps Script).
   Modos (window.SMAEL_CAPA.modo): 'rotacao' (cor da fatia de horas, definida no servidor), 'ab' (cada visitante vê
   uma cor fixa e diferente, ao mesmo tempo), 'fixa' (campeã gravada; não mede). Produto com campeã fica 'fixa' sempre. */
(function () {
  var cfg = window.SMAEL_CAPA;
  if (!cfg) return;

  /* ---------- aparelho interno (dono/equipe): abrir a loja com ?smael_interno=1 marca ESTE navegador para NÃO contar no teste
     (ele continua vendo as cores normalmente); ?smael_interno=0 desmarca. Vale só neste navegador, não afeta clientes. ---------- */
  var interno = false;
  try {
    var qi = /[?&]smael_interno=([01])/.exec(location.search);
    if (qi) { if (qi[1] === '1') localStorage.setItem('smael_interno', '1'); else localStorage.removeItem('smael_interno'); }
    interno = localStorage.getItem('smael_interno') === '1';
  } catch (e) {}

  /* ---------- links: o link do título (e qualquer outro link do produto) abre a mesma cor que o card mostra ---------- */
  function ajustarLinks(card, href) {
    var base = href.split('?')[0];
    card.setAttribute('data-smael-sync', '1');
    card.querySelectorAll('a[href]').forEach(function (a) {
      if (a.getAttribute('href').split('?')[0] === base) a.setAttribute('href', href);
    });
  }
  function sincronizarLinks() {
    document.querySelectorAll('product-card[data-smael-cor]:not([data-smael-sync])').forEach(function (card) {
      var alvo = card.querySelector('a.product-card__link');
      if (alvo && !card.hasAttribute('data-smael-ab')) ajustarLinks(card, alvo.getAttribute('href'));
    });
  }

  /* ---------- modo A/B: cor do visitante ---------- */
  var visitante = (function () {
    var id = null;
    try {
      id = localStorage.getItem('smael_cv');
      if (!id) { id = Math.random().toString(36).slice(2, 10) + Date.now().toString(36); localStorage.setItem('smael_cv', id); }
    } catch (e) {}
    return id || (Math.random().toString(36).slice(2, 10));
  })();

  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function larg(u, n) { return u.replace(/width=\d+/, 'width=' + n); }

  function sortear(card) {
    try {
      var ops = JSON.parse(card.getAttribute('data-smael-opcoes') || '[]');
      if (!ops.length) return;
      var o = ops[hash(visitante + '|' + card.getAttribute('data-smael-handle')) % ops.length];
      var img = card.querySelector('slideshow-slide img');
      if (img && o[2]) {
        var atual = (img.getAttribute('src') || '').split('?')[0];
        if (atual !== o[2].split('?')[0]) {
          img.removeAttribute('loading');
          img.src = larg(o[2], 832);
          img.srcset = [240, 352, 480, 620, 832, 1200, 1600].map(function (n) { return larg(o[2], n) + ' ' + n + 'w'; }).join(', ');
        }
      }
      var alvo = card.querySelector('a.product-card__link');
      if (alvo) ajustarLinks(card, alvo.getAttribute('href').split('?')[0] + '?variant=' + o[1]);
      card.setAttribute('data-smael-cor', o[0]);
      card.setAttribute('data-smael-fatia', 'ab');
      /* avisa o script de aura do tema que a foto mudou */
      document.body.appendChild(document.createComment('smael-capa'));
    } catch (e) {}
    card.setAttribute('data-smael-ok', '1');
  }

  function preparar() {
    document.querySelectorAll('product-card[data-smael-ab]:not([data-smael-ok])').forEach(sortear);
    sincronizarLinks();
  }
  preparar();
  if ('MutationObserver' in window) new MutationObserver(preparar).observe(document.body, { childList: true, subtree: true });

  /* ---------- medição ---------- */
  if (!cfg.endpoint || (cfg.modo !== 'rotacao' && cfg.modo !== 'ab')) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (interno) return;
  var ua = navigator.userAgent || '';
  if (navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|headless|preview|facebookexternalhit|pingdom|gtmetrix/i.test(ua)) return;

  var fila = [];
  var vistos = {};
  var pagina = (function () {
    var p = location.pathname;
    if (p === '/' || p === '') return 'h';
    if (p.indexOf('/collections') === 0) return 'c';
    if (p.indexOf('/search') === 0) return 'b';
    return 'o';
  })();
  var disp = window.innerWidth < 750 ? 'm' : 'd';

  function medivel(card) {
    var m = card.getAttribute('data-smael-modo');
    return m === 'rotacao' || m === 'ab';
  }
  function dados(card) {
    return [card.getAttribute('data-smael-handle'), card.getAttribute('data-smael-cor'), card.getAttribute('data-smael-fatia')];
  }

  function enviar() {
    if (!fila.length) return;
    var corpo = JSON.stringify({ v: 1, d: disp, p: pagina, e: fila.splice(0, fila.length) });
    try {
      if (!(navigator.sendBeacon && navigator.sendBeacon(cfg.endpoint, corpo))) {
        fetch(cfg.endpoint, { method: 'POST', mode: 'no-cors', keepalive: true, body: corpo });
      }
    } catch (e) {}
  }

  /* cada visitante conta no máximo UMA aparição e UM clique por card (produto+cor) por dia: a unidade do teste é "visitante-dia",
     assim quem atualiza a página 20 vezes ou clica 5 vezes não pesa mais que os outros */
  var hoje = new Date().toISOString().slice(0, 10);
  var memUnico = { d: hoje, i: {}, c: {} };
  function unico(tipo, chave) {
    var u = memUnico;
    try {
      var raw = JSON.parse(localStorage.getItem('smael_unico') || 'null');
      if (raw && raw.d === hoje) u = raw;
      else u = { d: hoje, i: {}, c: {} };
    } catch (e) {}
    if (u[tipo][chave]) return false;
    u[tipo][chave] = 1;
    memUnico = u;
    try { localStorage.setItem('smael_unico', JSON.stringify(u)); } catch (e) {}
    return true;
  }

  var timers = new WeakMap();
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (en) {
      var card = en.target;
      if (en.isIntersecting && en.intersectionRatio >= 0.5) {
        if (timers.has(card)) return;
        timers.set(card, setTimeout(function () {
          if (card.hasAttribute('data-smael-ab') && !card.hasAttribute('data-smael-ok')) return;
          var d = dados(card);
          var k = d.join('|');
          if (!vistos[k]) {
            vistos[k] = 1;
            if (unico('i', d[0] + '|' + d[1])) {
              fila.push([d[0], d[1], 'i', d[2]]);
              if (fila.length >= 20) enviar();
            }
          }
        }, 800));
      } else if (timers.has(card)) {
        clearTimeout(timers.get(card));
        timers.delete(card);
      }
    });
  }, { threshold: [0, 0.5] }) : null;

  function observar() {
    if (!io) return;
    document.querySelectorAll('product-card[data-smael-cor]:not([data-smael-obs])').forEach(function (c) {
      if (!medivel(c)) return;
      if (c.hasAttribute('data-smael-ab') && !c.hasAttribute('data-smael-ok')) return;
      c.setAttribute('data-smael-obs', '1');
      io.observe(c);
    });
  }

  document.addEventListener('click', function (ev) {
    var card = ev.target && ev.target.closest && ev.target.closest('product-card[data-smael-cor]');
    if (!card || !medivel(card)) return;
    var d = dados(card);
    if (ev.target.closest('a')) {
      if (unico('c', d[0] + '|' + d[1])) fila.push([d[0], d[1], 'c', d[2]]);
      gravarAtr({ h: d[0], c: d[1], f: d[2], t: Date.now(), q: 0 });
      enviar();
    } else if (ev.target.closest('[class*="quick-add"]')) {
      /* compra rápida no próprio card: o carrinho é atribuído a esta capa */
      gravarAtr({ h: d[0], c: d[1], f: d[2], t: Date.now(), q: 1 });
    }
  }, true);

  /* ---------- sinal de carrinho: o 'adicionar ao carrinho' é atribuído à capa em que a pessoa clicou (até 30 min depois) ---------- */
  function lerAtr() {
    try { return JSON.parse(sessionStorage.getItem('smael_atr') || 'null'); } catch (e) { return memAtr; }
  }
  var memAtr = null;
  function gravarAtr(o) {
    memAtr = o;
    try { sessionStorage.setItem('smael_atr', JSON.stringify(o)); } catch (e) {}
  }
  function registrarCarrinho() {
    var a = lerAtr();
    if (!a || a.n || Date.now() - a.t > 30 * 60 * 1000) return;
    if (!a.q && location.pathname.indexOf('/products/' + a.h) === -1) return;
    fila.push([a.h, a.c, 'a', a.f]);
    a.n = 1;
    gravarAtr(a);
    enviar();
  }
  if (window.fetch) {
    var fetchOrig = window.fetch;
    window.fetch = function (input) {
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (u.indexOf('/cart/add') > -1) registrarCarrinho();
      } catch (e) {}
      return fetchOrig.apply(this, arguments);
    };
  }

  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') enviar(); });
  window.addEventListener('pagehide', enviar);

  observar();
  if ('MutationObserver' in window) new MutationObserver(observar).observe(document.body, { childList: true, subtree: true });
})();
